
export const unidadeMedidaItemContratoEnum = {
    M: 1,
    M2: 2,
    M3: 3,
    H: 4,
    Diaria: 5,
    Mes: 6,
    DiariasPorAno: 7,
    MensalidadePorAno: 8,
    FurosPorAno: 9,
    Metro2PorAno: 10,
    AcaoPorAno: 11,
    HorasPorAno: 12,
    Unidade: 13,
    UnidadePorMes: 14,
    VeiculoPorMes: 15,
    ToneladaPorKM: 16,
    T: 17,
    UD: 18,
    CJ: 19,
    CHP: 20
}

export const unidadesMedidaItemContrato = [
    { id: 1, descricao: 'Metro' },
    { id: 2, descricao: 'Metro Quadrado' },
    { id: 3, descricao: 'Metro Cúbico' },
    { id: 4, descricao: 'Hora' },
    { id: 5, descricao: 'Diária' },
    { id: 6, descricao: 'Mes' },
    { id: 7, descricao: 'Diárias Por Ano' },
    { id: 8, descricao: 'Mensalidade Por Ano' },
    { id: 9, descricao: 'Furos Por Ano' },
    { id: 10, descricao: 'Metro Quadrado Por Ano' },
    { id: 11, descricao: 'Ação Por Ano' },
    { id: 12, descricao: 'Horas Por Ano' },
    { id: 13, descricao: 'Unidade Por Ano' },
    { id: 14, descricao: 'Unidade Por Mês' },
    { id: 15, descricao: 'Veículo Por Mês' },
    { id: 16, descricao: 'Tonelada Por Km' },
    { id: 17, descricao: 'Tonelada' },
    { id: 18, descricao: 'UD' },
    { id: 19, descricao: 'Conjunto' },
    { id: 20, descricao: 'Calor e Energia Combinados' }
]

export const unidadesMedidaItemContratoOrdenadasPorDescricao = unidadesMedidaItemContrato.slice().sort((a, b) =>
    (a.descricao || '').localeCompare((b.descricao || ''), 'pt-BR', { sensitivity: 'base' })
)